import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      {/*TODO*/}
    </React.Fragment>
  );
};
export default Footer;